/* PARFUMPROBEN VERSAND – Hinweise rund um den Warenkorb (gehört zu snippets/ppv-cart-pill.liquid und
   snippets/ppv-proben-warten.liquid):
   - 11d: Pille am Warenkorb-Symbol – rechnet nach jeder Änderung am Warenkorb neu (ppv:cart aus ppv-cart-rewards.js).
     Sie steht nur beim Ankommen auf einer Seite (auch nach Neuladen oder Zurück) und geht weg, sobald man ein Stück scrollt.
   - 12b: „Deine Proben warten“ unten auf Startseite und Kollektionen für Besucher, deren Warenkorb schon zu Beginn
     des Besuchs gefüllt war. Antippen öffnet den Warenkorb, das X schließt – beides für den Rest des Besuchs, ebenso
     jedes Öffnen des Warenkorbs auf irgendeiner Seite.
   - Schreibt auf Produktseiten mit, was zuletzt angesehen wurde (für „Zuletzt angesehen“ in ppv-cart-rewards.js). */
(() => {
  if (window.__PPV_CART_HINTS__) return;
  window.__PPV_CART_HINTS__ = true;

  const RECENT_KEY = 'ppv.zuletzt';
  const SESSION_KEY = 'ppv.probenwarten';
  const root = () => window.Shopify?.routes?.root || '/';
  const money = cents =>
    new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(Math.max(0, cents) / 100);
  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };
  const debounce = (fn, wait) => {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  };

  /* Schwellen wie im Einschub (snippets/ppv-cart-rewards.liquid) */
  const thresholds = () => {
    const source = document.querySelector('ppv-cart-rewards') || document.querySelector('.ppv-cart-pill');
    return {
      sample: Number(source?.dataset.sampleThreshold) || 3000,
      shipping: Number(source?.dataset.shippingThreshold) || 5000
    };
  };

  /* ---------- Zuletzt angesehen mitschreiben (neueste zuerst, höchstens 12) ---------- */
  if (window.PPV_PAGE_TYPE === 'product') {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (match) {
      try {
        const handle = decodeURIComponent(match[1]);
        const list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        const rest = (Array.isArray(list) ? list : []).filter(entry => entry && entry.h && entry.h !== handle);
        localStorage.setItem(RECENT_KEY, JSON.stringify([{ h: handle, t: Date.now() }, ...rest].slice(0, 12)));
      } catch (error) {
        /* Ohne Speicher gibt es eben keine Liste. */
      }
    }
  }

  /* ---------- 11d Pille am Warenkorb-Symbol ---------- */
  const pill = document.querySelector('.ppv-cart-pill');
  const pillText = pill && pill.querySelector('.ppv-cart-pill__t');
  const pillDesc = document.getElementById('PpvCartPillText');
  const cartIcon = () => document.getElementById('cart-icon-bubble');

  /* Rechts bündig unter dem Symbol, 4 px eingerückt (am Handy 16 px vom Rand), mittig auf der Unterkante der
     Kopfzeile – am PC ist das die schwebende Leiste, nicht der ganze Kopfbereich. Am PC bleibt die Pille unsichtbar,
     bis sie hier ihren Platz hat (ppv-cart-hints.css). */
  const placePill = () => {
    const host = pill && pill.offsetParent;
    const icon = cartIcon();
    if (!host || !icon) return;
    const hostRect = host.getBoundingClientRect();
    const right = hostRect.right - icon.getBoundingClientRect().right + 4;
    if (Number.isFinite(right)) pill.style.setProperty('--ppv-cart-pill-right', `${Math.round(right)}px`);
    const bar = host.querySelector('.header');
    if (bar) {
      const top = bar.getBoundingClientRect().bottom - hostRect.top - host.clientTop - pill.offsetHeight / 2;
      if (Number.isFinite(top)) pill.style.setProperty('--ppv-cart-pill-top', `${Math.round(top)}px`);
    }
    pill.classList.add('is-placed');
  };

  const renderPill = cart => {
    if (!pill) return;
    const { sample, shipping } = thresholds();
    const total = cart.total_price || 0;
    let state = 'empty';
    let text = '';
    let desc = '';
    if (cart.item_count > 0) {
      if (total < sample) {
        state = 'sample';
        text = `Noch ${money(sample - total)}`;
        desc = `${text} bis zur Gratisprobe`;
      } else if (total < shipping) {
        state = 'ship';
        text = `Noch ${money(shipping - total)}`;
        desc = `${text} bis zum Gratisversand`;
      } else {
        state = 'done';
        text = 'Versand gratis';
        desc = 'Gratisversand erreicht';
      }
    }
    const wasHidden = pill.hidden;
    pill.dataset.state = state;
    pill.hidden = state === 'empty';
    setText(pillText, text);
    setText(pillDesc, desc);
    if (wasHidden && !pill.hidden) placePill();
  };

  if (pill) {
    const icon = cartIcon();
    if (icon && pillDesc) icon.setAttribute('aria-describedby', pillDesc.id);
    /* Antippen wie das Symbol: öffnet den Warenkorb */
    pill.addEventListener('click', () => cartIcon()?.click());
    placePill();
    window.addEventListener('resize', debounce(placePill, 150));

    /* Nur beim Ankommen: Die Pille steht beim Öffnen, Neuladen oder Zurückkehren und ist weg, sobald man von dort aus
       mehr als 40 px nach unten scrollt – bis zur nächsten Seite, auch beim Zurückscrollen. Was der Browser vor der ersten
       Berührung selbst scrollt (alte Position wiederherstellen, Sprung zu einem #Anker), zählt noch zum Ankommen. */
    const AWAY_AFTER = 40;
    const INPUTS = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    let startY = 0;
    let touched = false;
    const onInput = () => {
      touched = true;
    };
    const stopWatching = () => {
      window.removeEventListener('scroll', awayOnScroll);
      INPUTS.forEach(type => window.removeEventListener(type, onInput, true));
    };
    const awayOnScroll = () => {
      const y = window.scrollY;
      if (!touched) {
        startY = y;
        return;
      }
      if (y - startY <= AWAY_AFTER) return;
      pill.classList.add('is-away');
      stopWatching();
    };
    const arrive = () => {
      pill.classList.remove('is-away');
      stopWatching();
      touched = false;
      startY = window.scrollY;
      INPUTS.forEach(type => window.addEventListener(type, onInput, { capture: true, passive: true }));
      window.addEventListener('scroll', awayOnScroll, { passive: true });
    };
    arrive();
    /* Zurück-Taste aus dem Seiten-Speicher des Browsers zählt als neues Ankommen */
    window.addEventListener('pageshow', event => {
      if (event.persisted) arrive();
    });
    if (window.ResizeObserver && pill.parentElement) {
      let frame = 0;
      new ResizeObserver(() => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          placePill();
        });
      }).observe(pill.parentElement);
    }
  }

  /* ---------- 12b Deine Proben warten ---------- */
  const float = document.querySelector('.ppv-pw');

  /* Besuch = Tab-Sitzung. Beim ersten Seitenaufruf merken, ob der Warenkorb schon gefüllt war. */
  const session = (() => {
    try {
      let value = JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null');
      if (!value) {
        value = { start: (Number(window.PPV_CART_COUNT) || 0) > 0, done: false };
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(value));
      }
      return value;
    } catch (error) {
      return null;
    }
  })();

  const markDone = () => {
    if (!session || session.done) return;
    session.done = true;
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
    } catch (error) {
      /* nichts */
    }
  };

  /* Fremdes unten (Trusted-Shops-Siegel, Rabatt-Hinweis von Shopify Forms …) bleibt, wie es ist – gelesen wird nur.
     Liegt so etwas in der Breite der Pille am unteren Rand, setzt sich die Pille mit 8 px Abstand darüber. */
  const fixedHolder = node => {
    while (node && node !== document.body && node !== document.documentElement) {
      if (node.nodeType === 1 && getComputedStyle(node).position === 'fixed') return node;
      const rootNode = node.getRootNode && node.getRootNode();
      node = node.parentElement || (rootNode && rootNode !== document ? rootNode.host : null);
    }
    return null;
  };

  const placeFloat = () => {
    if (!float || float.hidden) return;
    const viewport = window.innerHeight;
    const left = float.offsetLeft;
    const right = left + float.offsetWidth;
    const narrow = window.innerWidth < 750;
    const seen = new Set();
    let top = Infinity;
    [0.02, 0.2, 0.4, 0.6, 0.8, 0.98].forEach(share => {
      const x = left + (right - left) * share;
      [viewport - 2, viewport - 14, viewport - 30].forEach(y => {
        document.elementsFromPoint(x, y).forEach(element => {
          const stack = element.shadowRoot ? [...element.shadowRoot.elementsFromPoint(x, y), element] : [element];
          stack.forEach(node => {
            if (float.contains(node)) return;
            const holder = fixedHolder(node);
            if (!holder || holder === float || seen.has(holder)) return;
            seen.add(holder);
            /* Einschub und Vorschau-Leiste des Theme-Editors zählen nicht, am Handy auch nicht der Duftfinder-Knopf
               (der macht dort Platz) */
            if (holder.closest && holder.closest(narrow ? 'cart-drawer, [id^="PBar"], .ppv-finder' : 'cart-drawer, [id^="PBar"]')) return;
            const rect = holder.getBoundingClientRect();
            if (!rect.height || rect.height > viewport * 0.5 || rect.bottom < viewport - 40) return;
            if (rect.right <= left || rect.left >= right) return;
            top = Math.min(top, rect.top);
          });
        });
      });
    });
    if (Number.isFinite(top)) float.style.bottom = `${Math.ceil(viewport - top + 8)}px`;
    else float.style.removeProperty('bottom');
  };

  let floatCount = Number(window.PPV_CART_COUNT) || 0;
  let placeTimers = [];
  let placeInterval = 0;

  const hideFloat = () => {
    if (!float || float.hidden) return;
    float.hidden = true;
    float.classList.remove('is-in');
    document.body.classList.remove('ppv-pw-on');
    placeTimers.forEach(clearTimeout);
    clearInterval(placeInterval);
  };

  const showFloat = () => {
    if (!float || !float.hidden || !session || !session.start || session.done || floatCount < 1) return;
    if (document.querySelector('cart-drawer.active')) return;
    /* Am Handy macht der Duftfinder-Knopf Platz, solange die Pille steht (ppv-cart-hints.css) */
    document.body.classList.add('ppv-pw-on');
    float.hidden = false;
    placeFloat();
    float.classList.remove('is-in');
    void float.offsetWidth;
    float.classList.add('is-in');
    /* Siegel und Hinweise laden manchmal später nach – dann rückt die Pille nach oben. Danach reicht ein Blick alle 4 s. */
    placeTimers = [600, 1500, 3000].map(delay => setTimeout(placeFloat, delay));
    clearInterval(placeInterval);
    placeInterval = setInterval(placeFloat, 4000);
  };

  /* Bilder nur für neue Zeilen bauen – die vorhandenen (gleicher Zeilen-Schlüssel) bleiben, wie sie sind. */
  const renderFloat = cart => {
    if (!float) return;
    floatCount = cart.item_count || 0;
    if (!floatCount) {
      hideFloat();
      return;
    }
    setText(float.querySelector('.ppv-pw__sum'), money(cart.total_price || 0));
    const thumbs = float.querySelector('.ppv-pw__thumbs');
    if (!thumbs) return;
    const existing = new Map([...thumbs.children].map(span => [span.dataset.key, span]));
    const next = (cart.items || []).slice(0, 3).map(item => {
      const keep = existing.get(item.key);
      if (keep) return keep;
      const span = document.createElement('span');
      span.dataset.key = item.key;
      const src = item.image || (item.featured_image && item.featured_image.url) || '';
      if (src) {
        const img = document.createElement('img');
        img.src = `${src}${src.includes('?') ? '&' : '?'}width=96`;
        img.alt = '';
        img.width = 32;
        img.height = 32;
        span.appendChild(img);
      }
      return span;
    });
    const current = [...thumbs.children];
    if (next.length !== current.length || next.some((span, index) => current[index] !== span)) thumbs.replaceChildren(...next);
  };

  if (float) {
    float.querySelector('.ppv-pw__x')?.addEventListener('click', () => {
      markDone();
      hideFloat();
    });
    float.querySelector('.ppv-pw__go')?.addEventListener('click', event => {
      markDone();
      hideFloat();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(cartIcon() || event.currentTarget);
      else window.location.href = `${root()}cart`;
    });

    window.addEventListener('resize', debounce(placeFloat, 150));

    /* Kurz nach dem Laden hereingleiten – ein offener Cookie-Hinweis hat Vorrang. */
    const consentOpen = () => {
      const banner = document.getElementById('shopify-pc__banner');
      return Boolean(banner && banner.offsetHeight > 0 && getComputedStyle(banner).visibility !== 'hidden');
    };
    let tries = 0;
    const reveal = () => {
      if (consentOpen() && tries < 20) {
        tries += 1;
        setTimeout(reveal, 1500);
        return;
      }
      showFloat();
    };
    setTimeout(reveal, 600);
  }

  /* Wird der Warenkorb geöffnet – auf irgendeiner Seite –, hat die Erinnerung für diesen Besuch ihren Zweck erfüllt. */
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(() => {
      if (!drawer.classList.contains('active')) return;
      markDone();
      hideFloat();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* Die Warenkorb-Seite selbst erfüllt den Zweck ebenso. */
  if (window.location.pathname.replace(/\/$/, '') === `${root()}cart`) markDone();

  /* Aus dem Zurück-Speicher des Browsers: Wurde die Erinnerung inzwischen auf einer anderen Seite erledigt, bleibt sie weg. */
  window.addEventListener('pageshow', event => {
    if (!event.persisted || !session) return;
    try {
      const stored = JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null');
      if (stored && stored.done) session.done = true;
    } catch (error) {
      /* nichts */
    }
    if (session.done) hideFloat();
  });

  /* ---------- Warenkorb-Stand ---------- */
  const apply = cart => {
    if (!cart) return;
    renderPill(cart);
    renderFloat(cart);
  };

  /* Normalerweise liefert der Einschub (ppv-cart-rewards.js) jeden neuen Stand. Nur ohne ihn selbst nachlesen. */
  document.addEventListener('ppv:cart', event => apply(event.detail));
  if (!document.querySelector('ppv-cart-rewards')) {
    let refreshTimer;
    const refresh = () =>
      fetch(`${root()}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(response => (response.ok ? response.json() : null))
        .then(apply)
        .catch(() => {});
    const refreshSoon = delay => {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refresh, delay);
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshSoon(250));
    }
    window.addEventListener('pageshow', event => {
      if (event.persisted) refreshSoon(0);
    });
  }
})();
